var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1761)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6736_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03875 0 0 4.03875 0 9C0 13.9613 4.03875 18 9 18C13.9613 18 18 13.9613 18 9C18 4.03875 13.9613 0 9 0ZM14.4788 11.4019C13.2188 11.3175 11.9644 11.3738 11.4075 11.4075C11.2106 9.585 10.71 8.07187 10.4681 7.425C10.8675 6.90188 11.61 5.86688 12.1219 4.85437C12.9375 4.84312 14.0119 4.8825 15.1481 5.07937C15.4575 5.66437 16.1831 7.155 16.5206 8.89875C16.38 9.11812 15.6431 10.2263 14.4844 11.4075L14.4788 11.4019ZM9.3375 13.4719C8.67375 13.4775 7.07062 13.4437 5.32125 13.0219C5.16375 12.0769 4.53938 10.5075 4.28062 9.8775C4.41563 9.52312 4.905 8.35875 5.985 6.98625C6.49125 7.02563 8.76937 7.23375 9.96187 7.68937C10.2094 8.37 10.6987 9.9 10.8619 11.6663C10.1137 12.4481 9.62438 13.0725 9.33187 13.4663L9.3375 13.4719ZM15.3619 4.365L15.2325 4.5225C14.0681 4.32 12.9825 4.275 12.1444 4.29187C11.8856 3.94875 11.2444 3.195 10.08 2.30063C10.2881 1.98563 10.5188 1.65937 10.7719 1.3275C12.645 1.76062 14.265 2.86313 15.3675 4.365H15.3619ZM10.1531 1.215C9.88875 1.575 9.6525 1.92375 9.43875 2.25563C8.76375 2.50313 7.3575 3.0375 6.45188 3.5325C5.27063 3.375 4.20188 3.375 3.45938 3.40875C4.8825 1.99687 6.84 1.125 9 1.125C9.39375 1.125 9.77625 1.16438 10.1531 1.22063V1.215ZM2.91375 3.99938C3.50437 3.95438 4.60125 3.90375 5.87812 4.0275V6.23812C4.58437 7.7625 3.9825 9.10125 3.78562 9.6075H1.1475C1.13063 9.405 1.11937 9.20813 1.11937 9C1.11937 7.10437 1.79437 5.36063 2.91375 3.99938ZM3.74063 14.85C4.14 14.6587 4.78687 13.9444 5.13 13.5506C6.75 13.95 8.22937 14.0288 9.045 14.0344C10.0631 15.5531 10.9575 16.335 11.2331 16.5544C10.5244 16.7625 9.77625 16.8806 9 16.8806C6.975 16.8806 5.13562 16.11 3.74063 14.85ZM14.8275 14.2875V11.8406C15.8625 10.8 16.5656 9.81563 16.8581 9.3825C16.7681 11.2669 16.0144 12.9769 14.8275 14.2875Z",
    fill: "#8C8989"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6736_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/Football.e105cf8a9273a2f05e6e6ffcb0f1e951.svg";
export { ForwardRef as ReactComponent };